<div class="main-content">
	<div class="container-fluid">
		<div class="col-md-12">
			<div class="card pr-0 pl-0">
				<div class="card-header card-header-{{color}}-3">
					<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> RGA Return Shipping</h4>
					<p class="card-category"></p>
				</div>
				<div class="card-body">
					<div class="col-12 m-0 p-0" *ngIf="rgaHeader">
						<div class="row mb-3">
							<div class="col-md-6">
								<h5>RGA #{{ rgaHeader.orderno }}</h5>
								<p><strong>Vendor:</strong> {{ rgaHeader.supplierno }} - {{ rgaHeader.suppname }}</p>
								<p><strong>Date:</strong> {{ rgaHeader.orddate }}</p>
								<p *ngIf="rgaHeader.rga_type"><strong>Type:</strong> {{ getRgaTypeLabel(rgaHeader.rga_type) }}</p>
							</div>
						</div>
					</div>

					<div class="col-12 m-0 p-0">
						<div class="table table-responsive text-center" *ngIf="loadingRGA || loadingdetails">
							<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
								</circle>
							</svg>
							<div>
								<p>Loading RGA Details</p>
							</div>
						</div>
					</div>

					<div class="col-12 m-0 p-0" *ngIf="!loadingdetails && mustship.length > 0">
						<mat-form-field appearance="outline" class="ml-2 mr-2">
							<mat-label>Scan An Item</mat-label>
							<input #itemCodeRef matInput class="text-right" placeholder="Scan an Item" [formControl]="itemCode" (input)="itemScan()">
						</mat-form-field>
					</div>

					<div class="row border-bottom mt-2" *ngIf="mustship.length > 0">
						<div class="col-6 text-left">
							<p *ngIf="receivingorder">RGA #{{ receivingorder }}</p>
						</div>
						<div class="col-6 text-right">
							<button mat-raised-button color="accent" aria-label="complete shipping" (click)="completeShipping()">
								<mat-icon>send</mat-icon> Complete Shipping
							</button>
						</div>
						<div class="col-6 text-left mr-0 pr-0"><b>ITEM/RGA</b></div>
						<div class="col-6 text-right ml-0 text-nowrap"><b>DESC/SHIP/BIN</b></div>
					</div>

					<div class="row mt-2 mb-2" *ngIf="!mustship.length && !loadingRGA && !loadingdetails">
						<div class="col-12 text-center">
							<span class="alert alert-info">No Items To Ship</span>
						</div>
					</div>

					<div class="alert alert-danger" *ngIf="showError">
						{{ errorMessage }}
					</div>

					<ul class="list-unstyled" *ngIf="mustship.length > 0">
						<li *ngFor="let item of mustship">
							<div class="row border-bottom pickitem mt-2">
								<div class="col-12 col-md-6 mt-2 mr-auto ml-0">
									<span class="spec-label-large">ITEM</span>
									&nbsp;&nbsp;{{ item.stockid }}
									<br />
									<span class="spec-label-large">DESC:</span>&nbsp;&nbsp;
									{{ item.description }}
									<br />
									<span class="spec-label-large">QOH</span>&nbsp;&nbsp;
									({{ item.totalqoh }})
									&nbsp;&nbsp;
									<span class="spec-label-large">RGA#</span>&nbsp;&nbsp;
									{{ item.orderno }}
									<br />
									<span class="spec-label-large">ORDERED:</span>&nbsp;&nbsp;
									{{ item.quantityord }}
									&nbsp;&nbsp;
									<span class="spec-label-large">SENT:</span>&nbsp;&nbsp;
									{{ item.quantityrecd || 0 }}
									&nbsp;&nbsp;
									<span class="spec-label-large">PENDING:</span>&nbsp;&nbsp;
									<span [ngClass]="item.quantitypending > 0 ? 'text-danger' : 'text-success'">
										{{ item.quantitypending }}
									</span>
								</div>
								<div class="col-12 col-md-6 text-right ml-auto mr-0">
									<div class="row m-0 p-0">
										<div class="col-md-1" [ngClass]="{'alert-success': item.current_movement > 0, 'alert-danger': item.current_movement < 0}">
											<mat-icon class="mt-4" *ngIf="item.current_movement > 0">add</mat-icon>
											<mat-icon class="mt-4" *ngIf="item.current_movement < 0">remove</mat-icon>
										</div>
										<div class="col-md-1 mt-3 mr-2">
											<button mat-icon-button aria-label="split bin" (click)="addBin(item)">
												<mat-icon>call_split</mat-icon>
											</button>
										</div>
										<div class="col-md-9">
											TOTAL TO SHIP: <b>{{ calculateTotalShipped(item) }}</b> / <b>{{ item.quantitypending }}</b>
											<div class="row m-0 p-0" *ngFor="let b of item.bins">
												<div class="col-md-4 mt-2">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Bin</mat-label>
														<input matInput type="text" placeholder="Bin" [(value)]="b.bin" (input)="setBin($event.target.value, b)">
														<mat-error></mat-error>
														<span matSuffix *ngIf="item.bins.length > 1">
															<button mat-icon-button aria-label="remove bin" (click)="removeBin(b, item)" *ngIf="item.bins.length > 1">
																<mat-icon>remove</mat-icon>
															</button>
														</span>
													</mat-form-field>
													<small class="text-muted">Available: {{ b.quantity }}</small>
												</div>
												<div class="col-md-8 mt-auto mb-auto">
													<span class="" [ngClass]="calculateTotalShipped(item) < item.quantitypending ? 'text-warning': 'text-success'">
														<mat-form-field class="full-width" appearance="outline">
															<span matPrefix>
																<button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm" (click)="removePick(b, item)">
																	<small>
																		<i class="material-icons">remove</i>
																	</small>
																</button>
															</span>
															<input matInput type="text" class="text-right" [(ngModel)]="b.qty" [ngClass]="calculateTotalShipped(item) < item.quantitypending ? 'text-warning': 'text-success'" (blur)="setQty($event, item, b)" (focus)="selectText($event)">
															<span matSuffix> / <b>{{ item.quantitypending }}</b></span>
															<span matSuffix>
																<button class="btn btn-just-icon btn-white btn-fab btn-round btn-sm mr-2" (click)="addPick(b, item)">
																	<small><i class="material-icons">add</i></small>
																</button>
															</span>
															<span matSuffix>
																<mat-checkbox [checked]='calculateTotalShipped(item) == item.quantitypending' (change)="setCheckValue($event, item)" class="mat-checkbox mat-accent" data-item="{{ item.podetailitem }}"></mat-checkbox>
															</span>
															<mat-error *ngIf="showError && parseFloat(b.qty || 0) > parseFloat(b.quantity || 0)">{{errorMessage}}</mat-error>
														</mat-form-field>
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
